<template>
  <form class="footer__subscr" @submit.prevent="submit" ref="form">
    <h2 class="footer__subscr-title">{{ title }}</h2>
    <div class="footer__subscr-input-wrap">
      <input
        name="mail"
        type="text"
        :placeholder="placeholder"
        v-model="form.email"
        v-metrik-click="(e) => sendStat(e, 'clickSubscribeInputYM', 'Клик по полю email' )"
      >
      <span class="footer__subscr-input-err" v-if="$v.form.email.$error">Введите корректный e-mail</span>
    </div>
    <input class="footer__subscr-submit" type="submit" value="">
    <div class="popup" v-if="showConfirmPopup">
      <div class="popup__box modal-content">
        <span class="popup__close" @click="showConfirmPopup = false;"></span>
        <svg class="modal-content__icon" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="40" r="40" fill="#008458"/>
          <path d="M37.3335 44.2293L49.5895 31.9719L51.4761 33.8573L37.3335 47.9999L28.8481 39.5146L30.7335 37.6293L37.3335 44.2293Z" fill="white"/>
        </svg>
        <h2>Готово</h2>
        <p>Ваша подписка подтверждена.</p>
      </div>
    </div>
    <div class="popup" v-if="showSuccessPopup">
      <div class="popup__box modal-content">
        <span class="popup__close" @click="showSuccessPopup = false; resetForm();"></span>
        <svg class="modal-content__icon" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="40" r="40" fill="#008458"/>
          <path d="M37.3335 44.2293L49.5895 31.9719L51.4761 33.8573L37.3335 47.9999L28.8481 39.5146L30.7335 37.6293L37.3335 44.2293Z" fill="white"/>
        </svg>
        <h2>Почти готово</h2>
        <p>Ваша подписка оформлена, но не подтверждена. Для подтверждения подписки пройдите по ссылке в письме, направленном на почтовый адрес {{ form.email }}. </p>
      </div>
    </div>
    <div class="popup" v-if="showErrorPopup">
      <div class="popup__box modal-content">
        <span class="popup__close" @click="showErrorPopup = false"></span>
        <svg class="modal-content__icon" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="40" r="40" fill="#E52020"/>
          <path d="M40 38.1147L46.6 31.5147L48.4853 33.4L41.8853 40L48.4853 46.6L46.6 48.4853L40 41.8853L33.4 48.4853L31.5146 46.6L38.1146 40L31.5146 33.4L33.4 31.5147L40 38.1147Z" fill="white"/>
        </svg>
        <h2>Ошибка</h2>
        <p>{{ errorText }}</p>
      </div>
    </div>
  </form>
</template>

<script>
import {email, required} from "vuelidate/lib/validators";
import axios from 'axios';
import YMStat from "../tools/ymStat";

export default {
  name: 'SubscriptionForm',
  props: {
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '',
    },
    confirmed: {
      type: Boolean,
      default: false,
    },
    confirmError: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showSuccessPopup: false,
      showErrorPopup: this.confirmError.length > 0,
      errorText: this.confirmError,
      showConfirmPopup: this.confirmed,
      form: {
        email: '',
      }
    }
  },
  mounted() {
  },
  validations: {
    form: {
      email: {required, email},
    }
  },
  methods: {
    async submit(e) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          const response = await axios({
            url: '/bitrix/services/main/ajax.php?mode=class&c=dalee:subscribe_form&action=subscribeUser',
            method: 'POST',
            data: this.getFormData(),
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          if (response.data.status === 'error') {
            throw new Error(response.data.errors[0].message);
          }

          if (response.data.status === 'success') {
            this.showSuccessPopup = true;
            this.sendStat(e,'clickSubscribeInputYM', 'Успешная подписка' )
          }
        } catch (error) {
          this.showErrorPopup = true;
          this.errorText = error.message;
        }
      }
    },
    getFormData() {
      const form = new FormData();

      form.append('email', this.form.email);

      return form;
    },
    resetForm() {
      this.form = {
        email: '',
      };
      this.$nextTick(() => { this.$v.$reset() });
    },
    closePopup() {
      this.showSuccessPopup = false;
      this.resetForm();
    },
    sendStat(e, param, value){
      YMStat[param](value)
    },
  }
}
</script>
